import type TimeSuggestionsViewState from './schema/TimeSuggestionsViewState';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
interface TimeSuggestionsStore {
    viewStates: ObservableMap<string, TimeSuggestionsViewState>;
}

const store: TimeSuggestionsStore = {
    viewStates: new ObservableMap<string, TimeSuggestionsViewState>(),
};

export const getStore = createStore<TimeSuggestionsStore>('TimeSuggestionsStore', store);
